import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export class AzureService {
	public static getUserUsageMetric() {
		return Http.axios().get('/api/Azure/getUserMetrics', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}